/**
 * Aucor Navigation.js
 * -------------------
 *
 * Horizontally scrolling menu
 *
 */

// variables
var SETTINGS = {
  navBarTravelling: false,
  navBarTravelDirection: "",
  navBarTravelDistance: 150
};

var leftArrow = document.getElementById("leftArrow");
var rightArrow = document.getElementById("rightArrow");
var navContainer = document.getElementById("primary-navigation");
var navItems = document.getElementById("primary-navigation__items");

// add js class if js enabled
document.documentElement.classList.remove("no-js");
document.documentElement.classList.add("js");

// determine overflow, can be left, right or both directions
function determineOverflow(content, container) {

  var containerMetrics = container.getBoundingClientRect();
  var containerMetricsLeft = Math.floor(containerMetrics.left);
  var containerMetricsRight = Math.floor(containerMetrics.right);

  var contentMetrics = content.getBoundingClientRect();
  var contentMetricsLeft = Math.floor(contentMetrics.left);
  //  calculate contentMetricsRight this way because ie would calculate contentMetrics.right wrong for some reason
  var contentMetricsRight = content.scrollWidth + contentMetricsLeft - 1;

 if (containerMetricsLeft > contentMetricsLeft && containerMetricsRight < contentMetricsRight) {
      return "both";
  } else if (contentMetricsLeft < containerMetricsLeft) {
      return "left";
  } else if (contentMetricsRight > containerMetricsRight) {
      return "right";
  } else {
      return "none";
  }

}
navContainer.setAttribute("data-overflowing", determineOverflow(navItems, navContainer));
window.addEventListener("resize", function(){
  setTimeout(function () {
    navContainer.setAttribute("data-overflowing", determineOverflow(navItems, navContainer));
  }, 500);
});


// handle the scroll of the horizontal container
var last_known_scroll_position = 0;
var ticking = false;
function updateDataOverflow(scroll_pos) {
  navContainer.setAttribute("data-overflowing", determineOverflow(navItems, navContainer));
}
navContainer.addEventListener("scroll", function() {
  last_known_scroll_position = window.scrollY;
  if (!ticking) {
      window.requestAnimationFrame(function() {
          updateDataOverflow(last_known_scroll_position);
          ticking = false;
      });
  }
  ticking = true;
});

leftArrow.addEventListener("click", function() {
  // if currently scrolling, return
  if (SETTINGS.navBarTravelling === true) {
      return;
  }
  // content overflowing both sides or on the left
  if (determineOverflow(navItems, navContainer) === "left" || determineOverflow(navItems, navContainer) === "both") {
      // find how far this panel has been scrolled
      var availableScrollLeft = navContainer.scrollLeft;
      // if the space available is less than two lots of our desired distance, just move the whole amount
      // otherwise, move by the amount in the settings
      if (availableScrollLeft < SETTINGS.navBarTravelDistance * 2) {
          navItems.style.transform = "translateX(" + availableScrollLeft + "px)";
      } else {
          navItems.style.transform = "translateX(" + SETTINGS.navBarTravelDistance + "px)";
      }
      // remove no-transition class to get the animation
      navItems.classList.remove("primary-navigation__items-no-transition");
      // update settings
      SETTINGS.navBarTravelDirection = "left";
      SETTINGS.navBarTravelling = true;
  }
  // update data-overflowing attribute
  navContainer.setAttribute("data-overflowing", determineOverflow(navItems, navContainer));
});

// same as above but for the right arrow
rightArrow.addEventListener("click", function() {
  if (SETTINGS.navBarTravelling === true) {
      return;
  }
  if (determineOverflow(navItems, navContainer) === "right" || determineOverflow(navItems, navContainer) === "both") {

    //  calculate navBarRightEdge this way because ie would calculate navItems.getBoundingClientRect().right wrong for some reason
    var navBarRightEdge = navItems.scrollWidth + navItems.getBoundingClientRect().left;
    var navBarScrollerRightEdge = navContainer.getBoundingClientRect().right;
    var availableScrollRight = Math.floor(navBarRightEdge - navBarScrollerRightEdge);
    if (availableScrollRight < SETTINGS.navBarTravelDistance * 2) {
        navItems.style.transform = "translateX(-" + availableScrollRight + "px)";
    } else {
        navItems.style.transform = "translateX(-" + SETTINGS.navBarTravelDistance + "px)";
    }
    navItems.classList.remove("primary-navigation__items-no-transition");
    SETTINGS.navBarTravelDirection = "right";
    SETTINGS.navBarTravelling = true;
  }
  navContainer.setAttribute("data-overflowing", determineOverflow(navItems, navContainer));
});

navItems.addEventListener(
  "transitionend",
  function() {
      // get the value of the transform, apply that to the current scroll position (so get the scroll pos first) and then remove the transform
      var styleOfTransform = window.getComputedStyle(navItems, null);
      var tr = styleOfTransform.getPropertyValue("-webkit-transform") || styleOfTransform.getPropertyValue("transform");
      // if there is no transition we want to default to 0 and not null
      var amount = Math.abs(parseInt(tr.split(",")[4]) || 0);
      navItems.style.transform = "none";
      navItems.classList.add("primary-navigation__items-no-transition");
      // set scroll position
      if (SETTINGS.navBarTravelDirection === "left") {
          navContainer.scrollLeft = navContainer.scrollLeft - amount;
      } else {
          navContainer.scrollLeft = navContainer.scrollLeft + amount;
      }
      SETTINGS.navBarTravelling = false;
  },
  false
);

/**
 *  Show/hide search on mobile
 */
var search = document.getElementById('mobile-search');
var searchButton = document.getElementById('show-search');

searchButton.onclick = function() {
  if ( search.classList.contains('mobile-search__visible') ) {
    search.style.height = '0px';
    search.classList.remove('mobile-search__visible');

  } else {
    search.style.height = '65px';
    search.classList.add('mobile-search__visible');
  }
};
